import React, { useState } from 'react';
import { observer } from 'mobx-react';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { Modal, ModalHeader, ModalBody } from '@this/shared/ui/feedbacks/modal';
import { Carousel } from '@this/shared/ui/data_displays/carousel';
import type Item from '@this/domain/expenses/item';

interface Props {
  item: Item | null;
}

const ReceiptIconLink = observer(({ item }: Props) => {
  const [modalOpen, setModalOpen] = useState(false);

  if (!item) return null;

  const allFiles: Array<{ path: string; contentType?: string; filename?: string }> = [];
  if (item.receiptFilePath) {
    allFiles.push({ path: `/aiexpense/images/${item.receiptFilePath}` });
  }
  (item.receiptFiles || []).forEach(rf => {
    allFiles.push({
      path: `/aiexpense/images/${rf.filePath}`,
      contentType: rf.contentType,
      filename: rf.originalFilename
    });
  });

  if (allFiles.length === 0) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (allFiles.length === 1) {
      window.open(allFiles[0].path, '_blank', 'noopener,noreferrer');
    } else {
      setModalOpen(true);
    }
  };

  return (
    <>
      <div style={{ position: 'relative', display: 'inline-block', cursor: 'pointer' }} onClick={handleClick}>
        <div
          style={{
            display: 'block',
            background: "url('/images/clip.png') no-repeat",
            backgroundSize: 'contain',
            width: 20,
            height: 20
          }}
        />
        {allFiles.length > 1 && (
          <span
            style={{
              position: 'absolute',
              top: -6,
              right: -8,
              background: '#2592c8',
              color: '#fff',
              borderRadius: '50%',
              width: 16,
              height: 16,
              fontSize: 10,
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {allFiles.length}
          </span>
        )}
      </div>

      <div onClick={e => e.stopPropagation()}>
        <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
          <ModalHeader>領収書一覧（{allFiles.length}件）</ModalHeader>
          <ModalBody>
            <Carousel>
              {allFiles.map((f, i) => {
                const isPdf = f.contentType === 'application/pdf' || f.path.toLowerCase().endsWith('.pdf');
                return (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minHeight: 480,
                      padding: '16px 48px'
                    }}
                  >
                    {isPdf ? (
                      <a
                        href={f.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: 12,
                          textDecoration: 'none',
                          color: '#d32f2f'
                        }}
                      >
                        <PictureAsPdfIcon style={{ fontSize: 80, color: '#d32f2f' }} />
                        <span style={{ fontSize: 14 }}>{f.filename ?? 'PDF'}</span>
                        <span style={{ fontSize: 12, color: '#888' }}>クリックして開く</span>
                      </a>
                    ) : (
                      <a
                        href={f.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                      >
                        <img
                          src={f.path}
                          alt={f.filename ?? `領収書${i + 1}`}
                          style={{
                            maxWidth: '100%',
                            maxHeight: 460,
                            objectFit: 'contain'
                          }}
                        />
                      </a>
                    )}
                    <span style={{ marginTop: 8, fontSize: 12, color: '#888' }}>
                      {i + 1} / {allFiles.length}
                      {f.filename ? `　${f.filename}` : ''}
                    </span>
                  </div>
                );
              })}
            </Carousel>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
});

export default ReceiptIconLink;
